import loadable from '@loadable/component';
import { useState } from 'react';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Spinner from '../../components/Reusable/Spinner';
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
import usePatchHook from '../../customHooks/usePatchHook';
import usePostHook from '../../customHooks/usePostHook';
import CreateIcon from '../../Icons/CreateIcon';

//@ts-ignore
import { usePDFPrintHook } from '@careinfo/layout';
//@ts-ignore
import { tw } from '@careinfo/tailwind';

const EditManifestComponent = loadable(
  () => import('../../components/VehicleManifest/SwitchTab')
);

const EditVehicleManifest = () => {
  const { id } = useParams();
  const [searchParams, setSearchParms] = useSearchParams();
  const [defaultValue, setDefaultValue] = useState(null);
  const { data, refetch, isLoading } = useGetHook({
    queryKey: [`mainfest-${id}`, 'manifest'],
    url: `${APIS.VEHICLE_MANIFEST}${id}/`,
    params: {},
  });
  const { data: gridData, isLoading: isgridDataLoading } = useGetHook({
    queryKey: [`vehicle-status`],
    url: `${APIS.VEHICLE_STATUS}`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`manifest-${id}`, 'manifest'],
    navigateURL: '',
  });

  const handleStatusChange = (data: any) => {
    setDefaultValue(data);
  };

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.VEHICLE_MANIFEST}${id}/`;
    let formData = {
      ...values,
      allowed_cities:
        values?.allowed_cities && values?.allowed_cities?.length > 0
          ? values?.allowed_cities?.map((item: any) => item?.value)
          : [],
    };

    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  const { mutateAsync: ConsignmentMutateAsync } = usePostHook({
    queryKey: ['manifest-items'],
  });

  const { mutateAsync: removeitems, isPostLoading: isRemoved } = usePostHook({
    queryKey: ['manifest-items'],
    navigateURL: '',
  });

  const handleAttachConsignment = async (
    consignmentId: string,
    statusId: string,
    setError: any
  ) => {
    const url = `${APIS.VEHICLE_MANIFEST_ITEMS}`;
    let formData = {
      status: statusId,
      vehicle_manifest: id,
      tracking_number: consignmentId,
    };
    try {
      await ConsignmentMutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  const handleCheckConsignments = async (
    consignmentId: string,
    setError: any
  ) => {
    const url = `${APIS.VEHICLE_MANIFEST_ITEMS}receive-order/`;
    let formData = {
      tracking_number: consignmentId,
      vehicle_manifest: id,
    };
    try {
      await ConsignmentMutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const handleRemove = async (setError) => {
    const selectedOrder = searchParams.get('selectedItems')?.split(',');
    if (!selectedOrder?.length) {
      toast.error('Please select at least one order first');
      return;
    }
    const url = `${APIS.VEHICLE_MANIFEST_ITEMS}remove-order/`;
    let formData = {
      items: selectedOrder,
    };
    try {
      const res = await removeitems({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  const { downloadPrint, isPrintLoading } = usePDFPrintHook();

  const handlePrint = async () => {
    const url = `${APIS.VEHICLE_MANIFEST}${id}/print-pdf-vehicle-manifest/`;
    let formData = {};
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.error(err);
    }
  };
  const handleSplitPrint = async () => {
    const url = `${APIS.VEHICLE_MANIFEST}${id}/print-pdf-manifest-split/`;
    let formData = {};
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Vehicle Manifest
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditManifestComponent
          isLoading={isPatchLoading}
          data={data}
          handleEdit={handleEdit}
          handleAttachConsignment={handleAttachConsignment}
          handlePrint={handlePrint}
          isPrintLoading={isPrintLoading}
          id={id}
          handleRemove={handleRemove}
          isRemoved={isRemoved}
          defaultValue={defaultValue}
          gridData={gridData}
          handleCheckConsignments={handleCheckConsignments}
          setDefaultValue={setDefaultValue}
          handleStatusChange={handleStatusChange}
          handleSplitPrint={handleSplitPrint}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default EditVehicleManifest;
